module.exports = __webpack_public_path__ + "static/media/correctProtects.bfa3b45a.mp3";